import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DocTemplateService } from "src/app/services/docTemplate.service";
import { TemplatePlaceholders } from './templatePlaceholders'
import { ProcessService } from "src/app/services/process.service";
import { ConfirmationDialogComponent } from "../../dialogs/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { SharedService } from "src/app/services/sharedService";
import { TemplateService } from "src/app/services/template.service";
import { sanitizeReportHtml } from "src/app/util/sanitize-report-html";
@Component({
  selector: "app-template-editor",
  templateUrl: "./template-editor.component.html",
  styleUrls: ["./template-editor.component.css"],
})
export class TemplateEditorComponent implements OnInit {
  templateType: any;
  template
  placeholders
  subscriptionConfirm: any
  loading = { saveInProgress: false, downloadInProgress:false}
  constructor(private route: ActivatedRoute, private docTemplateService: DocTemplateService,
    private sharedService: SharedService,
    private dialog: MatDialog,
    private templateService: TemplateService) { }
  async ngOnInit() {
    this.templateType = this.route.snapshot.paramMap.get("template");
    this.placeholders = TemplatePlaceholders[this.templateType] || []
    this.template = await this.docTemplateService.getDocTemplateByType(this.templateType).toPromise() || {}
  }
  async saveEditor() {
    this.loading.saveInProgress = true
    this.template.type = this.templateType
    let res = await this.docTemplateService.updateResource('doc-template', this.template).toPromise()
    this.loading.saveInProgress = false
    if (res)
      this.template.id = res.id
  }

  appendText(text) {
    if (this.template.content) {
      if (this.template.content.includes(text)) {
        this.template.content = this.template.content.replace(text, '')
      } else
        this.template.content += " " + text;
    } else {
      this.template.content = text;
    }
    this.template.content = this.template.content.replace(/\s{2,}/g, ' ').trim()
  }

  async generatePDF() {
    this.loading.downloadInProgress = true
    let templateData = await this.templateService.getTemplateExample(this.template).toPromise()

    const container = document.createElement("div");
    container.style.position = "absolute";
    container.style.left = "-9999px";
    container.style.width = "100%";
    container.innerHTML = sanitizeReportHtml(templateData)
    document.body.appendChild(container);
    html2canvas(container, { allowTaint: true, useCORS: true })
      .then((canvas) => {
        document.body.removeChild(container);
        const imgData = canvas.toDataURL("image/jpeg", 0.7);
        const pdf = new jsPDF();
        const imgWidth = 190;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, "JPEG", 10, 10, imgWidth, imgHeight);
        pdf.save("avis-template-example-content.pdf");
        this.loading.downloadInProgress = false
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  }

  openSaveTemplateDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '500px',
      data: { text: "DIALOG.SAVE_" + this.templateType.toUpperCase(), emitter: null, obj: { templateType: this.templateType }, action: "CONFIRM" }
    });
    this.subscriptionConfirm = this.sharedService.confirmDialogEmitter.subscribe(val => {
      if (val) {
        this.saveEditor()
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      this.subscriptionConfirm.unsubscribe()
    });
  }

}
